import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useReducer } from "react";
import { PlannerResourceType } from "@parkschannel/contracts";
import { errorToast } from "../../Toast";
export const TripPlannerContext = /*#__PURE__*/ React.createContext(undefined);
export const useTripPlanerContext = ()=>{
    const ctx = React.useContext(TripPlannerContext);
    if (!ctx) throw new Error("Trip Planner Context not found");
    return ctx;
};
const DEFAULT_STATE = {
    name: "",
    filters: {
        [PlannerResourceType.PLACE]: [],
        [PlannerResourceType.ACTIVITY]: []
    },
    productIds: []
};
export const TripPlannerProvider = (param)=>{
    let { children , onSavePlan , initialChecklist  } = param;
    const [planner, dispatch] = useReducer(tripPlannerReducer, initialChecklist || DEFAULT_STATE);
    const isProductChecked = useCallback((productId)=>{
        return planner.productIds ? planner.productIds.findIndex((id)=>id === productId) > -1 : false;
    }, [
        planner.productIds
    ]);
    const onFilterChange = useCallback((filters)=>dispatch({
            type: "changeFilters",
            payload: filters
        }), []);
    const onNameChange = useCallback((value)=>dispatch({
            type: "changeName",
            payload: value
        }), []);
    const onToggleProduct = useCallback((productId)=>{
        if (isProductChecked(productId)) {
            dispatch({
                type: "uncheckProduct",
                payload: productId
            });
        } else {
            dispatch({
                type: "checkProduct",
                payload: productId
            });
        }
    }, [
        planner.productIds
    ]);
    const onSavePlanner = useCallback(async (newPlanner, onSuccess)=>{
        try {
            const { filters , ...rest } = newPlanner || planner;
            const uploadedPlan = {
                ...rest,
                filterIds: [
                    ...filters[PlannerResourceType.ACTIVITY],
                    ...filters[PlannerResourceType.PLACE]
                ]
            };
            if (!uploadedPlan.filterIds.length) {
                errorToast({
                    description: "You have to select at least one filter!"
                });
            } else {
                await (onSavePlan === null || onSavePlan === void 0 ? void 0 : onSavePlan(uploadedPlan));
                await (onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess());
            }
        } catch (err) {
            errorToast({
                description: "Something went wrong!"
            });
        }
    }, [
        planner
    ]);
    return /*#__PURE__*/ _jsx(TripPlannerContext.Provider, {
        value: {
            planner,
            onFilterChange,
            onToggleProduct,
            onSavePlanner,
            onNameChange,
            isProductChecked
        },
        children: children
    });
};
function tripPlannerReducer(state, action) {
    switch(action.type){
        case "changeName":
            return {
                ...state,
                name: action.payload
            };
        case "changeFilters":
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.payload.type]: action.payload.items
                }
            };
        case "uncheckProduct":
            var ref;
            return {
                ...state,
                productIds: (ref = state.productIds) === null || ref === void 0 ? void 0 : ref.filter((productId)=>productId !== action.payload)
            };
        case "checkProduct":
            return {
                ...state,
                productIds: state.productIds ? [
                    ...state.productIds,
                    action.payload
                ] : [
                    action.payload
                ]
            };
        default:
            throw new Error();
    }
}
